import { IAccountFormCreate, IAccountByIdRespDto, IAccountFormUpdate } from 'src/types'

const generateFormState = (state: IAccountByIdRespDto): IAccountFormUpdate => ({
  industry: state.industry ?? null,
  email: state.email ?? '',
  billing_email: state.billing_email ?? '',
  phone: state.phone ?? null,
  contact_person: state.contact_person ?? '',
  description: state.description ?? '',
  address: state.address ?? '',
  latitude: state.latitude ?? 0,
  longitude: state.longitude ?? 0,
  region: state.region,
  country: state.country,
  website: state.website,
  socials: state.socials,
  image: {
    icon: state.image || '',
    file: null,
  },
  image_small: state.image_small,
  image_medium: state.image_medium,
  account_holder: state.account_holder,
  media: state.media.map((item) => ({ ...item, file: null })),
  gln: state.gln,
  owner_email: state.owner?.user?.email || null,
  selectedImpacts: state.impact_options.map((item) => ({
    id: item.impact_id,
    home_page_show: item.home_page_show,
    impact_page_show: item.impacts_page_show,
    account_page_show: item.account_page_show,
  })),
})

const initialFormState: IAccountFormCreate = {
  email: '',
  phone: null,
  contact_person: '',
  description: '',
  address: '',
  latitude: 0,
  longitude: 0,
  website: null,
  socials: null,
  billing_email: '',
  image: {
    icon: '',
    file: null,
  },
  image_small: null,
  image_medium: null,
  account_holder: '',
  media: [],
  gln: '',
  country: '',
  region: '',
  industry: null,
  selectedImpacts: [],
}

export { generateFormState, initialFormState }
